module.exports = __webpack_public_path__ + "media/packs/landing_page/images/logo_white-b05c4d9e5a8ad6bb179e88ce3cbf5671.png";